<template>
    <wrapper>
        <div class="row">
            <div class="col m3">
                <router-link to="/your-exam"><div class="card">
                    <h4>EXAM</h4>
                </div></router-link>
            </div>
             <div class="col m3">
                <div class="card">
                    <h4>CLASS</h4>
                </div>
            </div>
        </div>
    </wrapper>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
        @import url('https://fonts.googleapis.com/css?family=Play&display=swap');
        .row
        {
            padding-top:30px;
        }
        .card
        {
            padding:30px;
            height:100px;
            display:flex;
            flex-direction:row;
            justify-content:center;
            align-items:center;
            background: #120c67;
            color:white;
            opacity:0.8;
            border-bottom:3px solid black;    
            font-family: 'Play', sans-serif;
            
        }
</style>